import { render, staticRenderFns } from "./TagList.vue?vue&type=template&id=60a89d79&scoped=true&"
var script = {}
import style0 from "./TagList.vue?vue&type=style&index=0&id=60a89d79&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a89d79",
  null
  
)

export default component.exports